<template>
  <div class="member-detail-modern">
    <material-loading :active="isLoading" />
    <div v-if="!isLoading">
      <div class="member-detail-header">
        <div class="left-header">
          <button class="back-btn" @click="backMember()">
            <i class="fa fa-arrow-left"></i>
            <span>Back</span>
          </button>
        </div>
        <div class="language-selector d-flex align-items-center justify-content-end">
          <div class="dropdown">
            <button
              class="dropdown-toggle p-0 mb-0"
              type="button"
              id="languageDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style="border: none; background: none; color: inherit; text-decoration: none;"
            >
              English
            </button>
            <ul class="dropdown-menu" aria-labelledby="languageDropdown" style="min-width: 120px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
              <li><a class="dropdown-item" href="#" @click="changeLanguage('en')">English</a></li>
              <li><a class="dropdown-item" href="#" @click="changeLanguage('cn')">Chinese</a></li>
            </ul>
          </div>
        </div>
      </div>

      <div class="member-detail-content mt-2">
        <!-- Left Column -->
        <div class="member-detail-left">
          <div class="member-card-header mb-1">
            <div class="avatar-placeholder">
              <i class="fa fa-user"></i>
            </div>
            <div class="member-id-status">
              <div class="id-row">
                <span><span class="id-label">ID:</span> {{ form.id }},</span>
                <span><span class="id-label">Member ID:</span> {{ form.member_id }}</span>
                <span class="status-badge" :class="form.block ? 'active' : 'inactive'">
                  {{ form.block ? "ACTIVE" : "INACTIVE" }}
                </span>
                <span class="status-badge reward-badge" v-if="form.reward_type_label" title="Current reward per transaction setting">
                  REWARD: {{ form.reward_type_label.toUpperCase() }}
                </span>
              </div>
            </div>
            <button class="btn update-btn" @click="updateProfileAndRemark()">Update</button>
          </div>

          <div class="member-card">
            <div class="member-form-fields">
              <div class="form-row">
                <div class="form-label">First Name</div>
                <input class="form-input name-input" v-model="form.name" type="text" />
              </div>
              <div class="form-row">
                <div class="form-label">Last Name</div>
                <input class="form-input name-input" v-model="form.last_name" type="text" />
              </div>
              <div class="form-row">
                <div class="form-label">Mobile</div>
                <div class="mobile-input-group">
                  <select class="form-input phone-code-select" v-model="form.phone_code">
                    <option v-for="c in countryData" :key="c.value" :value="c.value">{{ c.label }}</option>
                  </select>
                  <input class="form-input phone-number-input" v-model="form.phone_number" type="text" />
                </div>
              </div>
              <div class="form-row" v-if="form.branches.length > 0">
                <div class="form-label">Code</div>
                <div><input class="form-input" v-model="form.code" type="text" /></div>
              </div>
              <div class="form-row mt-3 mb-3" v-if="form.branches.length > 0">
                <div class="form-label mb-0">Remaining Limit:</div>
                <div class="font-weight-bold" style="color: #222">
                  {{ formatPrice(form.branches[0].remaining_spending) }}
                </div>
              </div>
              <div class="form-row">
                <div class="form-label">Date of Birth</div>
                <div class="date-of-birth-container">
                  <input class="form-input dob-input" v-model="form.date_of_birth" type="date" />
                  <span class="dob-inline-info" v-if="form.date_of_birth">
                    {{ calculateAge() }},
                    <span class="underline">{{ chineseZodiac() }}</span>,
                    <span class="underline">{{ horoscope() }}</span>
                  </span>
                </div>
              </div>
              <div class="form-row">
                <div class="form-label">Email Address</div>
                <input class="form-input" v-model="form.email" type="email" />
              </div>
            </div>
          </div>
        </div>

        <!-- Right Column -->
        <div class="member-detail-right mt-2">
          <div class="member-actions">
            <div class="action-card">
              <img src="@/assets/img/member/Tier.svg" alt="Tier" class="action-svg" />
              <span>Tier: {{ form.tier_name }}</span>
            </div>
            <div class="action-card" @click="openIssueVoucherModal()">
              <img src="@/assets/img/member/IssueVoucher.svg" alt="Issue Voucher" class="action-svg" />
              <span>Issue Voucher</span>
            </div>
            <!-- SF278: only for members linked to Advocado
                 (minty_members.advocado_member_id). -->
            <div class="action-card" v-if="form.has_advocado" @click="openAdvocadoVoucherModal()">
              <img src="@/assets/img/member/IssueVoucher.svg" alt="Issue Voucher Advocado" class="action-svg" />
              <span>Issue Voucher Advocado</span>
            </div>
            <div class="action-card" @click="gotoTopup()">
              <img src="@/assets/img/member/Topup.svg" alt="Topup" class="action-svg" />
              <span>Topup</span>
            </div>
            <div class="action-card" @click="openResetPinModal()">
              <img src="@/assets/img/member/NewPin.svg" alt="Reset Pin" class="action-svg" />
              <span>Reset Pin</span>
            </div>
          </div>

          <div class="member-stats">
            <div class="stat-card">
              <div class="stat-title">Total Spent</div>
              <div class="stat-value" :title="form.amount_spent">
                <span>{{ formatCurrencyForDisplay(form.amount_spent).integerPart }}</span>
                <span class="decimal-part">{{ formatCurrencyForDisplay(form.amount_spent).decimalPart }}</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-title">Wallet Balance</div>
              <div class="stat-value" :title="form.wallet_balance_format">
                <span>{{ formatCurrencyForDisplay(form.wallet_balance_format).integerPart }}</span>
                <span class="decimal-part">{{ formatCurrencyForDisplay(form.wallet_balance_format).decimalPart }}</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-title">Cashback Earned</div>
              <div class="stat-value" :title="form.amount_cashback_earned">
                <span>{{ formatCurrencyForDisplay(form.amount_cashback_earned).integerPart }}</span>
                <span class="decimal-part">{{ formatCurrencyForDisplay(form.amount_cashback_earned).decimalPart }}</span>
              </div>
            </div>
            <div class="stat-card">
              <div class="stat-title">Wallet Used</div>
              <div class="stat-value" :title="form.wallet_used">
                <span>{{ formatCurrencyForDisplay(form.wallet_used).integerPart }}</span>
                <span class="decimal-part">{{ formatCurrencyForDisplay(form.wallet_used).decimalPart }}</span>
              </div>
            </div>
            <div class="stat-card" v-if="form.is_point_merchant">
              <div class="stat-title">Points Balance</div>
              <div class="stat-value" :title="form.point_format">
                <span>{{ form.point_format }}</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="member-table-section position-relative mt-3">
            <div class="table-tabs">
              <button class="tab-btn" :class="{ active: filterType === 5 }" @click="getList(page, 'getMyTransaction', 5)">Purchase History</button>
              <button class="tab-btn" :class="{ active: filterType === 1 }" @click="getList(page, 'getListVocher', 1)">Rewards</button>
              <button class="tab-btn" :class="{ active: filterType === 4 }" @click="getList(page, 'getMyTransactionTopup', 4)">Topup History</button>
              <button class="tab-btn" :class="{ active: filterType === 2 }" @click="getList(page, 'getMyCashbackExpired', 2)">Value Expiry</button>
              <button class="tab-btn" :class="{ active: filterType === 3 }" @click="getList(page, 'getMemberPreference', 3)">Preference</button>
              <button class="tab-btn" :class="{ active: filterType === 6 }" @click="filterType = 6">Profiles</button>
              <div class="tab-actions">
                <button class="tab-btn reload-btn" @click="reloadData" :disabled="isReloading">
                  <i class="fa fa-refresh" :class="{ 'fa-spin': isReloading }"></i>
                </button>
                <div class="dropdown download-dropdown" v-if="filterType !== 3 && filterType !== 6">
                  <button class="download-btn dropdown-toggle" type="button" id="downloadDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="fa fa-download"></i>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="downloadDropdown" style="box-shadow: 0 2px 8px rgba(0,0,0,0.08)">
                    <li><a class="dropdown-item" href="#" @click.prevent="exportFile('csv', filterType)">CSV</a></li>
                    <li><a class="dropdown-item" href="#" @click.prevent="exportFile('xlsx', filterType)">Excel</a></li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Rewards Tab -->
            <div v-if="filterType === 1">
              <div class="table-search">
                <input type="search" placeholder="Search by Voucher Title" v-model="searchKeywordVoucher"
                  @input="onChangesearchKeyword(searchKeywordVoucher, 'getListVocher')" />
              </div>
              <div class="table-wrapper">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0 rewards-table">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder"></th>
                            <th class="text-center font-weight-bolder">ID</th>
                            <th class="text-center font-weight-bolder">Voucher Title</th>
                            <th class="text-left font-weight-bolder">Code</th>
                            <th class="text-center font-weight-bolder">Issue Date</th>
                            <th class="text-center font-weight-bolder">Expired Date</th>
                            <th class="text-center font-weight-bolder">Use Date</th>
                            <th class="text-center font-weight-bolder">Status</th>
                          </tr>
                        </thead>
                        <tbody v-if="vouchers.length">
                          <tr v-for="(value, key) in vouchers" :key="key">
                            <td class="text-center text-xss">
                              <div class="dropdown">
                                <i
                                  class="fa fa-ellipsis-v text-secondary cursor-pointer px-1"
                                  aria-hidden="true"
                                  data-bs-toggle="dropdown"
                                ></i>
                                <ul class="dropdown-menu dropdown-menu-action">
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click.prevent="voidVoucher(value)"
                                    >
                                      <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">block</i>
                                      <span>Void Voucher</span>
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td class="text-center text-xss">VOUCHER {{ value.id }}</td>
                            <td class="text-left text-xss">{{ value.reward_title }}</td>
                            <td class="text-center text-xss">{{ value.code }}</td>
                            <td class="text-center text-xss">{{ value.exchanged_date }}</td>
                            <td class="text-center text-xss">{{ value.expiry_date_text }}</td>
                            <td class="text-center text-xss">{{ value.redeemed_date }}</td>
                            <td class="text-center text-xss">{{ value.status_text }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr><td colspan="9" class="text-center">No item available</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination v-if="pagination.last_page > 1" :pagination="pagination"
                    :current_page="pagination.current_page" :last_page="pagination.last_page" pageTitle="getListVocher" />
                </div>
              </div>
            </div>

            <!-- Purchase History Tab -->
            <div v-if="filterType === 5">
              <div class="table-search">
                <input type="search" placeholder="Search by Transaction ID" v-model="searchKeywordPurchase"
                  @input="onChangesearchKeyword(searchKeywordPurchase, 'getMyTransaction')" />
              </div>
              <div class="table-wrapper">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder"></th>
                            <th class="text-center font-weight-bolder">Receipt No</th>
                            <th class="text-center font-weight-bolder">Timestamp</th>
                            <th class="text-center font-weight-bolder">Branch</th>
                            <th class="text-center font-weight-bolder">Txn Type</th>
                            <th class="text-center font-weight-bolder">Status</th>
                            <th class="text-center font-weight-bolder">Receipt Amount</th>
                            <th class="text-center font-weight-bolder">New Balance</th>
                            <th class="text-center font-weight-bolder">Deducted Topup</th>
                            <th class="text-center font-weight-bolder">Deducted Cashback/Bonus</th>
                            <th class="text-center font-weight-bolder">Added Topup</th>
                            <th class="text-center font-weight-bolder">Added Bonus</th>
                            <th class="text-center font-weight-bolder">Added Cashback</th>
                            <th class="text-center font-weight-bolder" v-if="showPointEarnedColumn">Added Points</th>
                            <th class="text-center font-weight-bolder">Txn ID</th>
                            <th class="text-center font-weight-bolder">Last Updated</th>
                            <th class="text-left font-weight-bolder">Member ID</th>
                            <th class="text-center font-weight-bolder">First Name</th>
                            <th class="text-center font-weight-bolder">Txn Remarks</th>
                          </tr>
                        </thead>
                        <tbody v-if="transaction.length">
                          <tr v-for="(value, key) in transaction" :key="key">
                            <td class="text-center text-xss">
                              <div class="dropdown">
                                <i
                                  class="fa fa-ellipsis-v text-secondary cursor-pointer px-1"
                                  aria-hidden="true"
                                  data-bs-toggle="dropdown"
                                ></i>
                                <ul class="dropdown-menu dropdown-menu-action">
                                  <li>
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click.prevent="voidTransaction(value)"
                                    >
                                      <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">block</i>
                                      <span>Void</span>
                                    </a>
                                  </li>
                                  <li v-if="value.amount_direct_deduct > 0">
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click.prevent="resendWaDeduction(value)"
                                    >
                                      <i class="fab fa-whatsapp me-1" style="font-size: 16px; vertical-align: middle;"></i>
                                      <span>Resend WA Deduction</span>
                                    </a>
                                  </li>
                                  <li v-if="canRefundTransaction(value)">
                                    <a
                                      class="dropdown-item"
                                      href="#"
                                      @click.prevent="openRefundModal(value)"
                                    >
                                      <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">undo</i>
                                      <!-- Allinpay card payments are voided (not the bill's own Void above) -->
                                      <span>{{ value.allinpay_card ? 'Void card payment' : 'Refund' }}</span>
                                    </a>
                                  </li>
                                  <li v-else-if="needsOatsRefund(value)">
                                    <span
                                      class="dropdown-item text-secondary"
                                      title="Allinpay only voids a card payment on the day it was taken, before the terminal is settled. Refund it in Allinpay OATS or with Allinpay's manual refund form: part of it is allowed, within 30 to 180 days depending on the card, and the MID needs enough balance."
                                    >
                                      <i class="material-icons me-1" style="font-size: 16px; vertical-align: middle;">info</i>
                                      <span>Refund via Allinpay OATS</span>
                                    </span>
                                  </li>
                                </ul>
                              </div>
                            </td>
                            <td class="text-center text-xss">{{ value?.receipt_no }}</td>
                            <td class="text-center text-xss">{{ value?.created_at_format }}</td>
                            <td class="text-center text-xss">{{ value?.branch_name }}</td>
                            <td class="text-center text-xss" :class="typeColorClass(value?.transaction_type)">{{ value?.transaction_type }}</td>
                            <td class="text-center text-xss">
                              {{ value?.status }}
                              <div
                                v-if="airwallexRefundNote(value)"
                                class="text-xxs"
                                :class="airwallexRefundNote(value).error ? 'text-danger' : 'text-secondary'"
                              >{{ airwallexRefundNote(value).text }}</div>
                            </td>
                            <td class="text-center text-xss">{{ (value?.transaction_type === 'Wallet Renewal' || value?.transaction_type === 'Wallet Expired') ? '-' : value?.total_amount_format }}</td>
                            <td class="text-center text-xss">{{ (value?.transaction_type === 'Wallet Renewal' || value?.transaction_type === 'Wallet Expired') ? '-' : value?.wallet_total_format }}</td>
                            <td class="text-center text-xss" :class="{ 'text-danger': isPositiveAmount(value?.deducted_topup_format) }">{{ isPositiveAmount(value?.deducted_topup_format) ? '-' : '' }}{{ value?.deducted_topup_format }}</td>
                            <td class="text-center text-xss" :class="{ 'text-danger': isPositiveAmount(value?.deducted_bonus_cashback_format) }">{{ isPositiveAmount(value?.deducted_bonus_cashback_format) ? '-' : '' }}{{ value?.deducted_bonus_cashback_format }}</td>
                            <td class="text-center text-xss" :class="{ 'text-success': isPositiveAmount(value?.topup_amount_format) }">{{ isPositiveAmount(value?.topup_amount_format) ? '+' : '' }}{{ value?.topup_amount_format }}</td>
                            <td class="text-center text-xss" :class="{ 'text-success': isPositiveAmount(value?.topup_bonus_format) }">{{ isPositiveAmount(value?.topup_bonus_format) ? '+' : '' }}{{ value?.topup_bonus_format }}</td>
                            <td class="text-center text-xss" :class="{ 'text-success': isPositiveAmount(value?.payment_amount_format) }">{{ isPositiveAmount(value?.payment_amount_format) ? '+' : '' }}{{ value?.payment_amount_format }}</td>
                            <td class="text-center text-xss" v-if="showPointEarnedColumn" :class="{ 'text-success': value?.point_earned > 0 }">{{ value?.point_earned > 0 ? '+' + value?.point_earned_format : '0' }}</td>
                            <td class="text-center text-xss">{{ value?.transaction_id }}</td>
                            <td class="text-center text-xss">{{ value?.updated_at_format }}</td>
                            <td class="text-center text-xss">{{ value?.member_id_format }}</td>
                            <td class="text-center text-xss">{{ form.name }}</td>
                            <td class="text-center text-xss">{{ value?.void_reason_label }}</td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr><td :colspan="showPointEarnedColumn ? 19 : 18" class="text-center">No item available</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination v-if="paginationTransaction.last_page > 1" :pagination="paginationTransaction"
                    :current_page="paginationTransaction.current_page" :last_page="paginationTransaction.last_page"
                    pageTitle="getMyTransaction" />
                </div>
              </div>
            </div>

            <!-- Topup History Tab -->
            <div v-if="filterType === 4">
              <div class="table-search">
                <input type="search" placeholder="Search by Transaction ID" v-model="searchKeywordTopup"
                  @input="onChangesearchKeyword(searchKeywordTopup, 'getMyTransactionTopup')" />
              </div>
              <div class="table-wrapper">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">Date Time</th>
                            <th class="text-center font-weight-bolder">Channel</th>
                            <th class="text-center font-weight-bolder">Total Added</th>
                            <th class="text-center font-weight-bolder">Paid Amount</th>
                            <th class="text-center font-weight-bolder">Bonus</th>
                            <th class="text-center font-weight-bolder">Payment Method</th>
                            <th class="text-center font-weight-bolder">Branch</th>
                            <th class="text-center font-weight-bolder">Transaction Type</th>
                            <th class="text-center font-weight-bolder">Action</th>
                          </tr>
                        </thead>
                        <tbody v-if="transactionTopup.length">
                          <tr v-for="(value, key) in transactionTopup" :key="key">
                            <td class="text-center text-xss">{{ value?.created_at_format }}</td>
                            <td class="text-center text-xss">{{ value.pos_id == 1 ? "Member App" : "POS at " + value.branch_name }}</td>
                            <td class="text-center text-xss">{{ value?.topup_amount_format }}</td>
                            <td class="text-center text-xss">{{ value?.payment_amount_format }}</td>
                            <td class="text-center text-xss">{{ value?.topup_bonus_format }}</td>
                            <td class="text-center text-xss">{{ value?.payment_method }}</td>
                            <td class="text-center text-xss">{{ value?.branch_name }}</td>
                            <td class="text-center text-xss">{{ value?.transaction_type }}</td>
                            <td class="text-center text-xss"><i class="fa fa-ellipsis-v"></i></td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr><td colspan="17" class="text-center">No item available</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination v-if="paginationTransactionTopup.last_page > 1" :pagination="paginationTransactionTopup"
                    :current_page="paginationTransactionTopup.current_page" :last_page="paginationTransactionTopup.last_page"
                    pageTitle="getMyTransactionTopup" />
                </div>
              </div>
            </div>

            <!-- Value Expiry Tab -->
            <div v-if="filterType === 2">
              <div class="table-wrapper">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th class="text-center font-weight-bolder">Expired Date</th>
                            <th class="text-center font-weight-bolder">Topup Expired</th>
                            <th class="text-center font-weight-bolder">Bonus Expired</th>
                            <th class="text-center font-weight-bolder">Cashback Expired</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody v-if="transactionCashbackExpired.length">
                          <tr v-for="(value, key) in transactionCashbackExpired" :key="key">
                            <td class="text-center text-xss">
                              <div class="d-flex flex-column">
                                <span v-if="value?.amount_expiry_date_format">{{ 'Topup: ' + value?.amount_expiry_date_format }}</span>
                                <span v-if="value?.bonus_expiry_date_format">{{ 'Bonus: ' + value?.bonus_expiry_date_format }}</span>
                                <span v-if="value?.earned_expiry_date_format">{{ 'Cashback: ' + value?.earned_expiry_date_format }}</span>
                              </div>
                            </td>
                            <td class="text-center text-xss" :class="{ 'text-danger': value?.topup_expired }">
                              {{ value?.topup_expired ? formatPrice(value?.topup_value_expired) : "$ 0.00" }}
                            </td>
                            <td class="text-center text-xss" :class="{ 'text-danger': value?.bonus_expired }">
                              {{ value?.bonus_expired ? formatPrice(value?.bonus_value_expired) : "$ 0.00" }}
                            </td>
                            <td class="text-center text-xss" :class="{ 'text-danger': value?.cashback_expired }">
                              {{ value?.cashback_expired ? formatPrice(value?.cashback_value_expired) : "$ 0.00" }}
                            </td>
                            <td class="text-center text-xss"></td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr><td colspan="6" class="text-center">No item available</td></tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination v-if="paginationCashbackExpired.last_page > 1" :pagination="paginationCashbackExpired"
                    :current_page="paginationCashbackExpired.current_page" :last_page="paginationCashbackExpired.last_page"
                    pageTitle="getMyCashbackExpired" />
                </div>
              </div>
            </div>

            <!-- Preference Tab -->
            <div v-if="filterType === 3">
              <div class="member-preference-card">
                <div class="preference-title">Member's Preference</div>
                <div class="preference-row" v-for="(value, key) in memberPreferenceData" :key="key">
                  <div class="form-label">{{ value.name }}</div>
                  <select class="form-input" v-model="value.value_selected"
                    @change="changeMemberPreference($event.target.value, value.id)">
                    <option v-for="opt in value.value_select" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Profiles Tab -->
            <div v-if="filterType === 6">
              <div class="profiles-tab-content">
                <div class="profiles-left">
                  <div class="member-card">
                    <div class="member-form-fields">
                      <div class="form-row">
                        <div class="form-label">Gender</div>
                        <div class="gender-input-container">
                          <input class="form-input short" v-model="form.gender" type="text" readonly />
                          <i v-if="form.gender === 'Male'" class="fa fa-mars gender-icon male-icon"></i>
                          <i v-else-if="form.gender === 'Female'" class="fa fa-venus gender-icon female-icon"></i>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="form-label">Remarks</div>
                        <textarea class="form-input" v-model="form.remark" rows="3" />
                      </div>
                      <div class="form-row">
                        <div class="form-label">Address 1</div>
                        <input class="form-input" v-model="form.address_1" type="text" />
                      </div>
                      <div class="form-row">
                        <div class="form-label">Address 2</div>
                        <input class="form-input" v-model="form.address_2" type="text" />
                      </div>
                      <div class="form-row">
                        <div class="form-label">Occupation</div>
                        <input class="form-input" v-model="form.occupation" type="text" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="profiles-right">
                  <div class="member-card profiles-meta-card">
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="meta">Created: {{ form.create_at_text }}</div>
                      <div class="meta">Updated: {{ form.update_at_text }}</div>
                    </div>
                    <div class="profiles-meta-action">
                      <button
                        class="disable-btn btn"
                        :class="{ green: !form.block }"
                        @click="changeStatus"
                        :disabled="isChangingStatus"
                      >
                        {{ form.block ? "Disable" : "Enable" }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <material-loading :active="loaderActive" />
      </div>

      <ChangePassCode :keyReload="keyReload" :member="form" />
      <TopupModal :member="form" :keyReload="keyReloadTopup" @topup-success="onTopupSuccess" />
      <IssueVoucherModal :member="form" :keyReload="keyReloadIssueVoucher" @voucher-issued="onVoucherIssued" />
      <ModalSelectAdvocadoVoucher
        :campaigns="advocadoCampaigns"
        :campaignDefault="advocadoCampaignId"
        :optionDefault="advocadoOptionId"
        :isCampaignRequire="isAdvocadoCampaignRequire"
        :isOptionRequire="isAdvocadoOptionRequire"
        :changeCampaign="changeAdvocadoCampaign"
        :changeOption="changeAdvocadoOption"
        :confirmIssue="confirmAdvocadoIssue"
      />
      <RefundModal
        ref="refundModal"
        :merchant-code="merchantCodeExport"
        @refunded="onRefunded"
        @error="onRefundError"
      />
      <!-- Void Transaction Modal -->
      <button style="display: none" type="button" class="btn-show-void-modal" data-bs-toggle="modal" data-bs-target="#modalVoidTransaction"></button>
      <div class="modal fade" id="modalVoidTransaction" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Void Transaction</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to void this transaction?</p>
              <p class="text-xss text-secondary mb-1">Transaction ID: <strong>{{ voidTransactionId }}</strong></p>
              <div class="mt-3">
                <label class="form-label">Reason <span class="text-danger">*</span></label>
                <select class="form-select" v-model="voidReason">
                  <option value="">-- Select a reason --</option>
                  <option v-for="option in voidReasonOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                </select>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-background btn-sm" :disabled="voidReason === ''" @click="confirmVoidTransaction">Yes</button>
              <button type="button" class="btn btn-primary btn-close-modal btn-sm btn-close-void-modal" data-bs-dismiss="modal">No</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Void Voucher Modal -->
      <button style="display: none" type="button" class="btn-show-void-voucher-modal" data-bs-toggle="modal" data-bs-target="#modalVoidVoucher"></button>
      <div class="modal fade" id="modalVoidVoucher" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Void Voucher</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <p>Are you sure you want to remove this voucher from the member?</p>
              <p class="text-xss text-secondary mb-1">Voucher <strong>{{ voidVoucherId }}</strong> {{ voidVoucherTitle }}</p>
              <p class="text-xss text-secondary mb-1">Voucher Code: <strong>{{ voidVoucherCode }}</strong></p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-success btn-background btn-sm" @click="confirmVoidVoucher">Yes</button>
              <button type="button" class="btn btn-primary btn-close-modal btn-sm btn-close-void-voucher-modal" data-bs-dismiss="modal">No</button>
            </div>
          </div>
        </div>
      </div>

      <div class="position-fixed top-1 end-1 z-index-2 message-success" style="z-index: 99999 !important;">
        <material-snackbar v-if="snackbar === 'danger' || snackbar === 'success'" title="" date=""
          :description="message" :icon="{ component: 'campaign', color: 'white' }" :color="snackbar"
          :close-handler="closeSnackbar" />
      </div>

      <form :action="`${actionDownload}/merchant/download-member-transactions/${this.$route.params.id}`" method="POST">
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="search_keyword_transaction" :value="searchKeywordPurchase" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadTransactionForm" type="submit" class="d-none" />
      </form>
      <form :action="`${actionDownload}/merchant/download-member-transactions-topup/${this.$route.params.id}`" method="POST">
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="search_keyword_transaction" :value="searchKeywordTopup" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadTransactionTopupForm" type="submit" class="d-none" />
      </form>
      <form :action="`${actionDownload}/merchant/download-member-rewards/${this.$route.params.id}`" method="POST">
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="search_keyword" :value="searchKeywordVoucher" />
        <input type="hidden" name="type" :value="filterType" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadForm" type="submit" class="d-none" />
      </form>
      <form :action="`${actionDownload}/merchant/download-member-cashback-expired/${this.$route.params.id}`" method="POST">
        <input type="hidden" name="merchantId" :value="merchantIdExport" />
        <input type="hidden" name="merchant_code" :value="merchantCodeExport" />
        <input type="hidden" name="token" :value="token" />
        <input type="hidden" name="action_export" :value="action_export" />
        <input type="hidden" name="action" value="export" />
        <input id="downloadCashbackExpiredForm" type="submit" class="d-none" />
      </form>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MemberService from "../../services/member.service";
import RefundModal from "./components/RefundModal.vue";
import { canRefundAirwallex, airwallexRefundNote } from "./components/airwallexRefund";
import MaterialLoading from "@/components/MaterialLoading.vue";
import $ from "jquery";
import TokenService from "../../services/token.service";
import Pagination from "@/components/Pagination.vue";
import MemberPreferenceService from "../../services/memberPreference.service";
import "@vueform/multiselect/themes/default.css";
import ChangePassCode from "./components/ChangePassCode.vue";
import TopupModal from "./components/TopupModal.vue";
import IssueVoucherModal from "./components/IssueVoucherModal.vue";
import ModalSelectAdvocadoVoucher from "@/components/ModalSelectAdvocadoVoucher.vue";
import TestService from "../../services/test.service";
export default {
  name: "MemberDetailModern",
  components: {
    ModalSelectAdvocadoVoucher,
    MaterialSnackbar,
    MaterialLoading,
    Pagination,
    ChangePassCode,
    TopupModal,
    IssueVoucherModal,
    RefundModal,
  },
  data() {
    return {
      loaderActive: false,
      isLoading: true,
      form: {
        id: 0,
        member_id: "",
        code: "",
        name: "",
        last_name: "",
        date_of_birth: "",
        gender: "",
        email: "",
        phone_number: "",
        address_1: "",
        address_2: "",
        postal_code: "",
        occupation: "",
        monthly_income_range: 1,
        marital_status: "",
        discovery_channel: "",
        country_id: "",
        education: "",
        create_at_text: "",
        update_at_text: "",
        tier_name: "",
        amount_spent: 0,
        amount_cashback_earned: 0,
        wallet_used: 0,
        wallet_balance: 0,
        wallet_balance_format: 0,
        reward_type: null,
        reward_type_label: "",
        share_info_profile: 0,
        total_visit: 0,
        last_visit_text: "",
        join_date_text: "",
        name_text: "",
        block: 1,
        remark: "",
        phone_code: "",
        branches: [],
      },
      snackbar: null,
      error: "",
      memberInfo: {},
      merchantCode: "",
      voidVoucherId: null,
      voidVoucherTitle: "",
      voidVoucherCode: "",
      voidTransactionId: null,
      voidTransactionType: null,
      voidReason: "",
      voidReasonOptions: [
        { value: 1, label: "Duplicate" },
        { value: 2, label: "Wrong order" },
        { value: 3, label: "Customer request" },
        { value: 4, label: "Testing" },
        { value: 5, label: "Others" },
      ],
      vouchers: [],
      searchKeywordVoucher: "",
      searchKeywordPurchase: "",
      searchKeywordTopup: "",
      pagination: {},
      page: 1,
      filterType: 5,
      action_export: "csv",
      actionDownload: process.env.VUE_APP_BASE_URL,
      token: TokenService.getLocalAccessToken(),
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCodeExport: localStorage.getItem("MERCHANT_CODE", ""),
      paginationTransaction: {},
      paginationTransactionTopup: {},
      paginationCashbackExpired: {},
      transaction: [],
      transactionTopup: [],
      transactionCashbackExpired: [],
      memberPreferenceData: [],
      allow_foreigner_phone_number: false,
      countryData: [],
      isChangingStatus: false,
      keyReload: "keyReload",
      keyReloadTopup: "keyReloadTopup",
      keyReloadIssueVoucher: "keyReloadIssueVoucher",
      advocadoCampaigns: [],
      advocadoCampaignId: "",
      advocadoOptionId: "",
      isAdvocadoCampaignRequire: false,
      isAdvocadoOptionRequire: false,
      showTopupModal: false,
      isReloading: false,
    };
  },
  computed: {
    // Point merchants always get the column; a merchant that switched to cashback
    // still sees it while the page has older purchases that earned points.
    showPointEarnedColumn() {
      return this.form.is_point_merchant || this.transaction.some((t) => t?.point_earned > 0);
    },
  },
  created() {
    this.loadAllData();
  },
  mounted() {
    const code = localStorage.getItem("MERCHANT_CODE", "");
    this.merchantCode = code ? `/${code}` : "";
  },
  methods: {
    voidVoucher(voucher) {
      this.voidVoucherId = voucher.id;
      this.voidVoucherTitle = voucher.reward_title;
      this.voidVoucherCode = voucher.code;
      $(".btn-show-void-voucher-modal").click();
    },
    async confirmVoidVoucher() {
      $(".btn-close-void-voucher-modal").click();
      this.showLoader();
      let memberId = this.$route.params.id;
      let dataForm = {
        voucher_id: this.voidVoucherId,
        code: this.voidVoucherCode,
      };
      await MemberService.voidMemberReward(memberId, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Voucher voided successfully";
            this.getListVocher();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response?.data?.result?.message || "An error occurred";
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    voidTransaction(transaction) {
      this.voidTransactionId = transaction.transaction_id;
      this.voidTransactionType = transaction.transaction_type;
      this.voidReason = "";
      $(".btn-show-void-modal").click();
    },
    canRefundTransaction(transaction) {
      // Only "Spent" transactions paid through a gateway Minty can give money
      // back on: Airwallex (refund), or a kiosk card on its Allinpay terminal
      // (void, today before the terminal is settled), and only while there's
      // still some paid amount that has not been refunded yet.
      if (!transaction || transaction.transaction_type !== "Spent") {
        return false;
      }
      if (!transaction.airwallex_order_id && !transaction.allinpay_card) {
        return false;
      }
      // Airwallex: the BE works out what is still refundable (RefundSummary);
      // an API without those fields yet keeps the check below.
      if (!transaction.allinpay_card && transaction.airwallex_refundable !== undefined) {
        return canRefundAirwallex(transaction);
      }
      if (transaction.allinpay_card) {
        // A void still being confirmed is checked from the modal.
        if (transaction.allinpay_refund_pending) return true;
        if (!transaction.allinpay_voidable) return false;
      }
      const paid = Number((transaction.allinpay_card ? transaction.payment_amount : transaction.total_amount) || 0);
      const refunded = Number(transaction.total_refund_amount || 0);
      return paid > 0 && refunded < paid;
    },
    // Allinpay card payment past its void window, not given back yet.
    needsOatsRefund(transaction) {
      if (!transaction || !transaction.allinpay_card || transaction.allinpay_voidable || transaction.allinpay_refund_pending) return false;
      return Number(transaction.total_refund_amount || 0) < Number(transaction.payment_amount || 0);
    },
    airwallexRefundNote,
    openRefundModal(transaction) {
      this.$refs.refundModal.open(transaction);
    },
    onRefunded(event) {
      // Modal has already self-closed via this.close() inside RefundModal.
      // Re-fetch the Purchase History so the just-refunded row shows the
      // new total_refund_amount (and the Refund button disappears when the
      // transaction is now fully refunded). Refresh member detail too so
      // Total Spent / Wallet stats reflect any backend recompute.
      this.snackbar = "success";
      this.message = event?.message || "Refund successful";
      this.setTimeOutNotification();
      this.getMyTransaction(this.page);
      this.getMemberDetail();
    },
    onRefundError(message) {
      this.snackbar = "danger";
      this.message = message;
      this.setTimeOutNotification();
    },
    async confirmVoidTransaction() {
      $(".btn-close-void-modal").click();
      this.showLoader();
      let dataForm = {
        phone_number: this.form.phone_number,
        transaction_id: this.voidTransactionId,
        void_reason: this.voidReason,
        void_by: "Admin",
        // Tells the API this void came from the portal, so it pushes it to the POS.
        source: "merchant",
      };
      const isTopUp = this.voidTransactionType === "Top Up";
      const serviceCall = isTopUp
        ? TestService.voidTopup(dataForm)
        : TestService.voidTransaction(dataForm);
      await serviceCall.then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Transaction voided successfully";
            this.getMyTransaction();
            this.getMemberDetail();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response?.data?.result?.message || "An error occurred";
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    async resendWaDeduction(transaction) {
      if (!confirm("Are you sure you want to resend WA deduction notification for this transaction?")) {
        return;
      }
      this.showLoader();
      let memberId = this.$route.params.id;
      await MemberService.resendWaDeduction(memberId, {
        transaction_id: transaction.transaction_id,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "WA deduction notification sent successfully";
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response?.data?.result?.message || "An error occurred";
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },
    gotoTopup() {
      this.keyReloadTopup = Math.random();
      $(".show-topup-modal").click();
    },
    openResetPinModal() {
      this.keyReload = Math.random();
      $(".show-modal-change-pass-code").click();
    },
    openIssueVoucherModal() {
      this.keyReloadIssueVoucher = Math.random();
      $(".show-issue-voucher-modal").click();
    },

    // SF278 — issue an Advocado voucher to this one member.
    openAdvocadoVoucherModal() {
      this.advocadoCampaigns = [];
      this.advocadoCampaignId = "";
      this.advocadoOptionId = "";
      this.isAdvocadoCampaignRequire = false;
      this.isAdvocadoOptionRequire = false;
      $(".btn-select-advocado-voucher-modal").click();
      this.showLoader();
      MemberService.getAdvocadoVoucherCampaigns().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.advocadoCampaigns = response.data.data.campaigns;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    changeAdvocadoCampaign(campaignId) {
      this.advocadoCampaignId = campaignId;
      this.isAdvocadoCampaignRequire = false;
      // Options belong to the campaign, so a previous pick is no longer valid.
      this.advocadoOptionId = "";
    },

    changeAdvocadoOption(optionId) {
      this.advocadoOptionId = optionId;
      this.isAdvocadoOptionRequire = false;
    },

    confirmAdvocadoIssue() {
      this.isAdvocadoCampaignRequire = !this.advocadoCampaignId;
      this.isAdvocadoOptionRequire = !this.advocadoOptionId;
      if (this.isAdvocadoCampaignRequire || this.isAdvocadoOptionRequire) {
        return;
      }
      $(".btn-close-advocado-voucher-modal").click();
      this.showLoader();
      MemberService.bulkAdvocadoVoucher({
        member_ids: [this.$route.params.id],
        campaign_id: this.advocadoCampaignId,
        option_id: this.advocadoOptionId,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const data = response.data.data;
            if (data.sent_count) {
              this.snackbar = "success";
              this.message = "Advocado voucher sent";
            } else {
              // One member, so a skip or a failure is the whole outcome — show
              // Advocado's own reason instead of a bare "0 sent".
              const reason =
                data.failed?.[0]?.message ||
                data.skipped?.[0]?.message ||
                "Could not send the voucher";
              this.snackbar = "danger";
              this.message = reason;
            }
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    async loadAllData() {
      this.isLoading = true;
      try {
        await Promise.all([
          this.getCountriesForDropdown(),
          this.getMemberDetail(),
          this.getList(this.page, 'getMyTransaction'),
        ]);
      } catch (error) {
        this.snackbar = "danger";
        this.message = error;
        this.setTimeOutNotification();
      } finally {
        this.isLoading = false;
      }
    },
    formatPrice(price) {
      price = parseFloat(price).toFixed(2);
      return "$ " + price.toLocaleString("en-US", { minimumFractionDigits: 2 });
    },
    typeColorClass(transactionType) {
      return {
        'text-success': transactionType === 'Wallet Renewal',
        'text-danger': transactionType === 'Wallet Expired',
      };
    },
    isPositiveAmount(formattedPrice) {
      if (!formattedPrice) return false;
      const num = parseFloat(String(formattedPrice).replace(/[^0-9.-]/g, ''));
      return num > 0;
    },
    exportFile(type = "csv", filterType) {
      this.action_export = type;
      setTimeout(() => {
        if (filterType == 1) { $("#downloadForm").click(); }
        else if (filterType == 2) { $("#downloadCashbackExpiredForm").click(); }
        else if (filterType == 5) { $("#downloadTransactionForm").click(); }
        else if (filterType == 4) { $("#downloadTransactionTopupForm").click(); }
      }, 150);
    },
    backMember() {
      var page = this.$route.query.page;
      if (page) { this.$router.push("/members" + "?page=" + page); }
      else { this.$router.push("/members"); }
    },
    closeSnackbar() { this.snackbar = null; },
    getMemberDetail() {
      return new Promise((resolve, reject) => {
        var memberId = this.$route.params.id;
        this.isLoadDoneData = false;
        MemberService.getDataMemberDetail(memberId).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.memberInfo = response.data.data.member;
              this.setDataprofile(this.memberInfo);
              this.isLoadDoneData = true;
              resolve();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              reject(response.data.result.message);
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            reject(error);
          }
        );
      });
    },
    setDataprofile(memberInfor) {
      let formData = this.form;
      formData.id = memberInfor?.id_text;
      formData.member_id = memberInfor?.member_id_text;
      formData.code = memberInfor?.code;
      formData.name = memberInfor?.name;
      formData.last_name = memberInfor?.last_name;
      if (memberInfor && memberInfor.gender == 1) { formData.gender = "Male"; }
      else if (memberInfor && memberInfor.gender == 2) { formData.gender = "Female"; }
      else { formData.gender = ""; }
      formData.email = memberInfor?.email;
      formData.address_1 = memberInfor?.address_1;
      formData.address_2 = memberInfor?.address_2;
      formData.phone_number = memberInfor?.phone_number;
      formData.occupation = memberInfor?.occupation;
      formData.date_of_birth = memberInfor?.date_of_birth;
      formData.create_at_text = memberInfor?.create_at_text;
      formData.update_at_text = memberInfor?.update_at_text;
      formData.tier_name = memberInfor?.tier_name;
      // setDataprofile copies field by field: a field missing here silently never
      // reaches the template, which is why the Advocado action would not show.
      formData.has_advocado = memberInfor?.has_advocado ?? false;
      formData.wallet_balance = memberInfor?.wallet_balance;
      formData.wallet_balance_format = memberInfor?.wallet_balance_format;
      formData.amount_spent = memberInfor?.amount_spent;
      formData.amount_cashback_earned = memberInfor?.amount_cashback_earned;
      formData.wallet_used = memberInfor?.wallet_used;
      formData.point_format = memberInfor?.point_format;
      formData.is_point_merchant = memberInfor?.is_point_merchant ?? false;
      formData.reward_type = memberInfor?.reward_type ?? null;
      formData.reward_type_label = memberInfor?.reward_type_label ?? "";
      formData.share_info_profile = memberInfor?.share_info_profile;
      formData.last_visit_text = memberInfor?.last_visit_text;
      formData.total_visit = memberInfor?.total_visit;
      formData.join_date_text = memberInfor?.join_date_text;
      formData.block = memberInfor?.block;
      formData.name_text = memberInfor?.name_text;
      formData.monthly_income_range = this.annualIncomeRange(memberInfor?.monthly_income_range);
      formData.remark = memberInfor?.remark;
      formData.phone_code = memberInfor?.phone_code;
      formData.branches = memberInfor?.branches || [];
    },
    annualIncomeRange(value) {
      var occupationText = "";
      switch (value) {
        case 1: occupationText = "$0 - $3,000"; break;
        case 2: occupationText = "$3,001 - $6,000"; break;
        case 3: occupationText = "$6,001 - $9,000"; break;
        case 4: occupationText = "Above $9,000"; break;
        default: occupationText = "$0 - $3,000"; break;
      }
      return occupationText;
    },
    changeStatus() {
      this.isChangingStatus = true;
      this.showLoader();
      var memberId = this.$route.params.id;
      MemberService.changeStatus(memberId).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Change Member Success";
            this.form.block = !this.form.block;
            this.getMemberDetail();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.isChangingStatus = false;
          this.hideLoader();
          this.setTimeOutNotification();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.isChangingStatus = false;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    onChangesearchKeyword(searchKeyword, title) {
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        if (title === "getListVocher") { this.searchKeywordVoucher = searchKeyword; this.getListVocher(this.page); }
        else if (title === "getMyTransaction") { this.searchKeywordPurchase = searchKeyword; this.getMyTransaction(this.page); }
        else if (title === "getMyTransactionTopup") { this.searchKeywordTopup = searchKeyword; this.getMyTransactionTopup(this.page); }
      }, 1000);
    },
    changeType(type) {
      $("ul.member-detail-voucher-tab >li").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      this.filterType = type;
      this.getListVocher(this.page);
    },
    async getList(page, pageTitle = 'getListVocher', filterType = 0) {
      if (filterType) { this.filterType = filterType; }
      try {
        const actions = {
          getMyTransaction: () => this.getMyTransaction(page),
          getMyTransactionTopup: () => this.getMyTransactionTopup(page),
          getListVocher: () => this.getListVocher(page),
          getMyCashbackExpired: () => this.getCashbackExpired(page),
          getMemberPreference: () => this.getMemberPreference(),
        };
        if (actions[pageTitle]) { await actions[pageTitle](); }
        else { console.warn(`Unknown pageTitle: ${pageTitle}`); }
      } catch (error) {
        console.error('Error in getList:', error);
      }
    },
    getListVocher(page) {
      this.isLoadData = false;
      this.vouchers = [];
      this.showLoader();
      var memberId = this.$route.params.id;
      var dataForm = { type: this.filterType, search_keyword: this.searchKeywordVoucher, page: page };
      return MemberService.myRewards(memberId, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.vouchers = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          throw error;
        }
      ).finally(() => { this.hideLoader(); });
    },
    getMyTransaction(page) {
      this.isLoadData = false;
      this.transaction = [];
      this.showLoader();
      var memberId = this.$route.params.id;
      var dataForm = { search_keyword_transaction: this.searchKeywordPurchase, page: page };
      return MemberService.myTransaction(memberId, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transaction = response.data.data.items;
            this.paginationTransaction = response.data.data;
            this.page = this.paginationTransaction.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          throw error;
        }
      ).finally(() => { this.hideLoader(); });
    },
    getMyTransactionTopup(page) {
      this.isLoadData = false;
      this.transactionTopup = [];
      this.showLoader();
      var memberId = this.$route.params.id;
      var dataForm = { search_keyword_transaction: this.searchKeywordTopup, page: page };
      return MemberService.myTransactionTopup(memberId, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionTopup = response.data.data.items;
            this.paginationTransactionTopup = response.data.data;
            this.page = this.paginationTransactionTopup.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          throw error;
        }
      ).finally(() => { this.hideLoader(); });
    },
    getCashbackExpired(page) {
      this.isLoadData = false;
      this.transactionCashbackExpired = [];
      this.showLoader();
      var memberId = this.$route.params.id;
      var dataForm = { page: page };
      return MemberService.getCashbackExpired(memberId, dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.transactionCashbackExpired = response.data.data.items;
            this.paginationCashbackExpired = response.data.data;
            this.page = this.paginationCashbackExpired.current_page;
            this.isLoadData = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
          throw error;
        }
      ).finally(() => { this.hideLoader(); });
    },
    setTimeOutNotification() {
      setTimeout(() => { this.snackbar = null; }, 3000);
    },
    showLoader() { this.loaderActive = true; },
    hideLoader() { this.loaderActive = false; },
    updateProfileAndRemark() {
      this.isLoadData = false;
      this.showLoader();
      var memberId = this.$route.params.id;
      var dataForm = {
        member_id: memberId,
        phone_number: this.form.phone_number,
        code: this.form.code,
        name: this.form.name,
        last_name: this.form.last_name,
        email: this.form.email,
        date_of_birth: this.form.date_of_birth,
        remark: this.form.remark,
        phone_code: this.form.phone_code,
      };
      MemberService.updateProfileAndRemark(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Update Member Profile Success";
            this.getMemberDetail();
            this.isLoadData = true;
            this.setTimeOutNotification();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },
    getMemberPreference() {
      return new Promise((resolve, reject) => {
        var memberId = this.$route.params.id;
        this.isLoadData = false;
        MemberPreferenceService.getListDropdown(memberId).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.memberPreferenceData = response.data.data;
              this.isLoadData = true;
              resolve();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              reject(response.data.result.message);
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            reject(error);
          }
        );
      });
    },
    changeMemberPreference(value_select_id, id) {
      if (value_select_id && id) {
        var memberId = this.$route.params.id;
        this.isLoadData = false;
        this.showLoader();
        MemberPreferenceService.changeMemberPreference({
          memberId,
          minty_merchant_preference_value_id: value_select_id,
          minty_merchant_preference_id: id,
        }).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Update Member Preference Success";
              this.setTimeOutNotification();
              this.getMemberPreference();
              this.isLoadData = true;
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },
    getCountriesForDropdown() {
      return new Promise((resolve, reject) => {
        MemberService.getCountriesForDropdown().then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.countryData = response.data.data;
              this.isLoadData = true;
              resolve();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
              reject(response.data.result.message);
            }
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            reject(error);
          }
        );
      });
    },
    calculateAge() {
      if (!this.form.date_of_birth) return "";
      const today = new Date();
      const birthDate = new Date(this.form.date_of_birth);
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) { age--; }
      return "Age: " + age;
    },
    chineseZodiac() {
      if (!this.form.date_of_birth) return "";
      const zodiacSigns = ["Rat","Ox","Tiger","Rabbit","Dragon","Snake","Horse","Goat","Monkey","Rooster","Dog","Pig"];
      const birthYear = new Date(this.form.date_of_birth).getFullYear();
      return "Year of " + zodiacSigns[(birthYear - 4) % 12];
    },
    horoscope() {
      if (!this.form.date_of_birth) return "";
      const birthDate = new Date(this.form.date_of_birth);
      const month = birthDate.getMonth() + 1;
      const day = birthDate.getDate();
      if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) return "Aries";
      if ((month === 4 && day >= 20) || (month === 5 && day <= 20)) return "Taurus";
      if ((month === 5 && day >= 21) || (month === 6 && day <= 20)) return "Gemini";
      if ((month === 6 && day >= 21) || (month === 7 && day <= 22)) return "Cancer";
      if ((month === 7 && day >= 23) || (month === 8 && day <= 22)) return "Leo";
      if ((month === 8 && day >= 23) || (month === 9 && day <= 22)) return "Virgo";
      if ((month === 9 && day >= 23) || (month === 10 && day <= 22)) return "Libra";
      if ((month === 10 && day >= 23) || (month === 11 && day <= 21)) return "Scorpio";
      if ((month === 11 && day >= 22) || (month === 12 && day <= 21)) return "Sagittarius";
      if ((month === 12 && day >= 22) || (month === 1 && day <= 19)) return "Capricorn";
      if ((month === 1 && day >= 20) || (month === 2 && day <= 18)) return "Aquarius";
      return "Pisces";
    },
    formatCurrencyForDisplay(value) {
      const formattedValue = value || "S$ 0.00";
      const parts = formattedValue.replace(/S\$\s?/, "").split(".");
      return {
        integerPart: `${parts[0]}`,
        decimalPart: parts[1] ? `.${parts[1]}` : ".00",
      };
    },
    voidTopup(value) {
      console.log("Void Topup clicked", value);
    },
    async reloadData() {
      if (this.isReloading) return;
      this.isReloading = true;
      try {
        switch (this.filterType) {
          case 1: await this.getListVocher(this.page); break;
          case 2: await this.getCashbackExpired(this.page); break;
          case 3: await this.getMemberPreference(); break;
          case 4: await this.getMyTransactionTopup(this.page); break;
          case 5: await this.getMyTransaction(this.page); break;
        }
      } catch (error) {
        console.error("Failed to reload data", error);
      } finally {
        this.isReloading = false;
      }
    },
    onTopupSuccess() {
      this.getMyTransactionTopup(this.page);
      this.getMemberDetail();
    },
    onVoucherIssued() {
      this.getListVocher(this.page);
    },
  },
};
</script>

<style scoped>
/* ===== BASE ===== */
.member-detail-modern {
  box-sizing: border-box;
  background: #f2f2f2;
  min-height: 100vh;
  padding: 16px;
  font-family: "Inter", Arial, sans-serif;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* ===== HEADER ===== */
.member-detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 4px;
}

.left-header {
  display: flex;
  align-items: center;
}

.back-btn {
  border-radius: 8px;
  padding: 8px 18px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  border: none;
  background: transparent;
}

.language-selector {
  flex-shrink: 0;
}

/* ===== LAYOUT ===== */
.member-detail-content {
  display: flex;
  gap: 16px;
}

.member-detail-left {
  flex: 0 0 40%;
  max-width: 40%;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.member-detail-right {
  flex: 0 0 calc(60% - 16px);
  max-width: calc(60% - 16px);
  display: flex;
  flex-direction: column;
  gap: 0;
  min-width: 0;
}

/* ===== CARDS ===== */
.member-card,
.member-preference-card {
  background: #fff;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

/* ===== PROFILES TAB ===== */
.profiles-tab-content {
  display: flex;
  gap: 16px;
  align-items: stretch;
}

.profiles-left {
  flex: 0 0 60%;
  max-width: 60%;
  min-width: 0;
}

.profiles-right {
  flex: 0 0 calc(40% - 16px);
  max-width: calc(40% - 16px);
  min-width: 0;
}

.profiles-left > .member-card,
.profiles-right > .member-card {
  height: 100%;
}

.profiles-meta-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 12px;
}

.profiles-meta-action {
  display: flex;
  justify-content: flex-end;
}

@media (max-width: 768px) {
  .profiles-tab-content {
    flex-direction: column;
  }
  .profiles-left,
  .profiles-right {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

/* ===== MEMBER CARD HEADER ===== */
.member-card-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.avatar-placeholder {
  font-size: 28px;
  flex-shrink: 0;
}

.member-id-status {
  flex: 1;
  min-width: 0;
}

.id-row {
  font-size: 0.95rem;
  font-weight: 500;
  color: #222;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
}

.id-label {
  color: #888;
  font-weight: 500;
}

.status-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 7px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.status-badge.active {
  background: #34c759;
  color: #fff;
}

.status-badge.inactive {
  background: #d32f2f;
  color: #fff;
}

.status-badge.reward-badge {
  background: #e8f0fe;
  color: #1a56db;
}

.update-btn {
  background: #2677d9 !important;
  color: #fff !important;
  border: none !important;
  margin-bottom: 0 !important;
  white-space: nowrap;
  flex-shrink: 0;
}

.disable-btn {
  background: #d32f2f !important;
  color: #fff !important;
  border: none !important;
  margin-bottom: 0 !important;
}

.disable-btn.green {
  background: #34c759 !important;
}

.disable-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

/* ===== FORM ===== */
.member-form-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.form-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 0;
}

.form-label {
  min-width: 120px;
  flex-shrink: 0;
  font-size: 14px;
  color: #222;
}

.form-input {
  flex: 1;
  padding: 6px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  background: #fff;
  color: #222;
  font-family: inherit;
  outline: none;
  transition: border 0.2s;
  min-width: 0;
  width: 100%;
}

.form-input:focus {
  border: 1.5px solid #133067;
}

.form-input.short {
  max-width: 125px;
  min-width: 70px;
  flex: 0 0 auto;
}

/* Mobile group for phone input */
.mobile-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.phone-code-select {
  flex: 0 0 110px;
  width: 110px;
}

.phone-number-input {
  flex: 1;
}

.meta {
  color: #888;
}

/* ===== DATE OF BIRTH ===== */
.date-of-birth-container {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1;
  flex-wrap: wrap;
  min-width: 0;
}

.dob-input {
  flex: 0 0 auto;
  width: auto;
  min-width: 140px;
}

.dob-inline-info {
  color: #a1001a;
  font-weight: bold;
  font-size: 0.9rem;
  white-space: nowrap;
}

.dob-inline-info .underline {
  text-decoration: underline;
}

/* ===== GENDER ===== */
.gender-input-container {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}

.gender-icon {
  position: absolute;
  right: 10px;
  font-size: 16px;
  pointer-events: none;
}

.male-icon { color: #2677d9; }
.female-icon { color: #e91e63; }

/* ===== ACTION CARDS ===== */
.member-actions {
  display: flex;
  gap: 12px;
  justify-content: space-evenly;
  background: #fff;
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-wrap: wrap;
}

.action-card {
  background: #fff;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  font-size: 0.9rem;
  color: #222;
  cursor: pointer;
  min-width: 100px;
  text-align: center;
  flex: 1;
}

.action-svg {
  width: 45px;
  height: 50px;
}

/* ===== STATS ===== */
.member-stats {
  display: flex;
  gap: 10px;
  padding: 15px;
  background: #fff;
  border-radius: 10px;
  justify-content: space-evenly;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  flex-wrap: wrap;
}

.stat-card {
  background: #f2f2f2;
  border-radius: 10px;
  flex: 1;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 120px;
  min-height: 110px;
}

.stat-title {
  font-size: 0.9rem;
  color: #444;
}

.stat-value {
  margin-top: auto;
  font-size: 1.8rem;
  font-weight: 700;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  cursor: pointer;
}

.stat-value .decimal-part {
  font-size: 0.75rem;
  font-weight: 600;
}

/* ===== TABLE SECTION ===== */
.member-table-section {
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.table-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  flex-wrap: wrap;
}

.tab-btn {
  background: #eaeaea;
  border: none;
  border-radius: 10px;
  padding: 7px 10px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  color: #222;
  transition: background 0.2s, color 0.2s;
  white-space: nowrap;
}

.tab-btn.active {
  background: #2677d9;
  color: #fff;
}

.tab-actions {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.reload-btn {
  color: #2677d9;
  background: #fff;
  padding: 7px 12px;
}

.download-btn {
  background: #fff;
  border: none;
  border-radius: 8px;
  padding: 6px 10px;
  cursor: pointer;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.table-search {
  margin: 12px 0;
  display: flex;
  justify-content: center;
}

.table-search input[type="search"] {
  width: 80%;
  max-width: 500px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 0.9rem;
  background: #fafafa;
  color: #222;
}

.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* ===== PREFERENCE ===== */
.member-preference-card {
  margin-top: 0;
  padding: 16px;
}

.preference-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 12px;
}

.preference-row {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
}

/* ===== RESPONSIVE: TABLET (≤ 1024px) ===== */
@media (max-width: 1024px) {
  .member-detail-content {
    flex-direction: column;
    gap: 12px;
  }

  .member-detail-left,
  .member-detail-right {
    flex: 1 1 100%;
    max-width: 100%;
  }

  .stat-card {
    min-height: 90px;
  }

  .stat-value {
    font-size: 1.5rem;
  }
}

/* ===== RESPONSIVE: MOBILE (≤ 600px) ===== */
@media (max-width: 600px) {
  .member-detail-modern {
    padding: 10px;
  }

  .back-btn {
    padding: 6px 12px;
    font-size: 0.9rem;
  }

  /* Card header stacking */
  .member-card-header {
    gap: 6px;
  }

  .id-row {
    font-size: 0.82rem;
  }

  .update-btn {
    font-size: 0.85rem;
    padding: 5px 10px;
  }

  /* Form rows stack on mobile */
  .form-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }

  .form-label {
    min-width: unset;
    font-size: 13px;
    font-weight: 600;
  }

  .form-input {
    width: 100%;
    font-size: 14px;
  }

  .form-input.short {
    max-width: 100%;
    width: 100%;
  }

  .mobile-input-group {
    width: 100%;
  }

  .phone-code-select {
    flex: 0 0 100px;
    width: 100px;
  }

  .gender-input-container {
    width: 100%;
  }

  .date-of-birth-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    width: 100%;
  }

  .dob-input {
    width: 100%;
    min-width: unset;
  }

  .dob-inline-info {
    font-size: 0.85rem;
    white-space: normal;
  }

  .disable-btn {
    margin-top: 4px;
    width: 100%;
  }

  /* Actions: 2x2 grid on mobile */
  .member-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 12px;
  }

  .action-card {
    min-width: unset;
    padding: 10px 8px;
    font-size: 0.85rem;
  }

  /* Stats: 2x2 grid on mobile */
  .member-stats {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 12px;
  }

  .stat-card {
    min-width: unset;
    min-height: 80px;
    flex: unset;
  }

  .stat-value {
    font-size: 1.3rem;
  }

  /* Table section */
  .member-table-section {
    padding: 12px 10px;
  }

  .table-tabs {
    gap: 4px;
  }

  .tab-btn {
    padding: 6px 8px;
    font-size: 0.78rem;
    border-radius: 8px;
  }

  .table-search input[type="search"] {
    width: 100%;
  }

  .preference-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
}

/* ===== RESPONSIVE: SMALL TABLETS (601–900px) ===== */
@media (min-width: 601px) and (max-width: 900px) {
  .member-actions {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .action-card {
    min-width: unset;
  }

  .member-stats {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .stat-card {
    flex: unset;
    min-height: 90px;
  }
}

/* ===== MEDIUM SCREENS: avoid cramped labels ===== */
@media (min-width: 1025px) and (max-width: 1380px) {
  .form-label {
    min-width: 105px;
    font-size: 13px;
  }

  .form-input {
    font-size: 13px;
  }

  .stat-value {
    font-size: 1.4rem;
  }

  .action-card {
    min-width: 80px;
    font-size: 0.82rem;
  }
}

.dropdown:not(.dropdown-hover) .dropdown-menu-action.dropdown-menu.show {
  margin-top: 1.5rem !important;
}

.table-responsive.custom-table {
  overflow-y: hidden !important;
}

.text-success {
  color: #34c759 !important;
}
</style>